/*
 * src/utils/service/service_pdf-download.js
 * Description: PDF ReadableStream download utilities
 * Copyright (c) 2020 Mark Fehrenbacher
 */
import axios from "axios";

/**
 * Just the promise
 * @param {*} url
 */
export const downloadPdfPromise = (url) => {
  return axios({
    method: "get",
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.REACT_APP_AUTH_TOKEN}`,
    },
    url,
  });
};

/**
 * Promise + resolve
 * @param {*} url
 */
const downloadPdf = (url) =>
  axios({
    method: "get",
    responseType: "blob", // <--- this is key
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.REACT_APP_AUTH_TOKEN}`,
    },
    url,
  }).then((response) => response.data);

export default downloadPdf;
